import { render, staticRenderFns } from "./RemoveUserPresetButton.vue?vue&type=template&id=39f66069&scoped=true&"
import script from "./RemoveUserPresetButton.vue?vue&type=script&lang=ts&"
export * from "./RemoveUserPresetButton.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveUserPresetButton.vue?vue&type=style&index=0&id=39f66069&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f66069",
  null
  
)

export default component.exports